import { MuiClassCollection } from "../../foundations/mui-class-collection.es.js";
import { Spacing } from "../../foundations/spacing.es.js";
import { LineHeight, LetterSpacing } from "../../foundations/typography.es.js";
import { CursorStyle } from "../../foundations/cursor-style.es.js";
const buttonStyleOverrides = {
  root: function MuiButtonRootStyle({
    ownerState
  }) {
    return {
      ...buttonStyles[ownerState.size || "medium"],
      [`&.${MuiClassCollection.disabled}`]: {
        pointerEvents: "initial",
        cursor: CursorStyle.notAllowed
      }
    };
  },
  startIcon: {
    marginLeft: Spacing["0"]
  },
  endIcon: {
    marginRight: Spacing["0"]
  }
};
const buttonStyles = {
  large: {
    padding: `${Spacing["500"]} ${Spacing["1000"]}`,
    lineHeight: LineHeight.xl,
    letterSpacing: LetterSpacing.widerMedium,
    minWidth: Spacing["5000"],
    minHeight: Spacing["3000"]
  },
  medium: {
    padding: `${Spacing["500"]} ${Spacing["750"]}`,
    lineHeight: LineHeight.md,
    letterSpacing: LetterSpacing.wider,
    minWidth: Spacing["4000"],
    minHeight: Spacing["2500"]
  },
  small: {
    padding: `${Spacing["250"]} ${Spacing["500"]}`,
    lineHeight: LineHeight.sm,
    letterSpacing: LetterSpacing.widerMedium,
    minWidth: Spacing["3500"],
    minHeight: Spacing["2000"]
  }
};
export {
  buttonStyleOverrides
};
//# sourceMappingURL=styles.es.js.map
